import type { Api } from '@pflegenavi/shared-frontend/platform';
import {
  get,
  getApiBaseUrl,
  superFetch,
} from '@pflegenavi/shared-frontend/platform';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';
import type { UserProfileControllerResultTypes } from '@pflegenavi/service-provider-shared/api-endpoints';
import { UserProfileControllerDefinition } from '@pflegenavi/service-provider-shared/api-endpoints';
import type { UpdateUserProfileOptionalInfoDto } from '@pflegenavi/shared/api';

export interface IUserProfileApi extends Api {
  getUserProfile(): Promise<UserProfileControllerResultTypes['getUserProfile']>;

  updateUser(data: UpdateUserProfileOptionalInfoDto): Promise<{
    id: string;
  }>;
}

export class UserProfileApi implements IUserProfileApi {
  baseUrl: string;

  getUserProfile: IUserProfileApi['getUserProfile'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    this.baseUrl = getApiBaseUrl(tenantId, apiUrl);

    this.getUserProfile = get({
      authContext,
      url: `${this.baseUrl}/${UserProfileControllerDefinition.controller}/${UserProfileControllerDefinition.endpoints.getUserProfile.url}`,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  get headers(): Headers {
    return new Headers({
      'content-type': 'application/json',
    });
  }

  async updateUser(data: UpdateUserProfileOptionalInfoDto): Promise<{
    id: string;
  }> {
    const result = await superFetch(
      this.authContext,
      `${this.baseUrl}/userProfile/profile`,
      {
        method: 'PUT',
        headers: this.headers,
        body: JSON.stringify(data),
      }
    );
    return result.json();
  }
}
